<template>
  <div class="navbar">
    <header class="header">
      <!-- Logo -->
      <div class="logo">
        <router-link to="/" class="logo-link">
          <div class="logo-icon-wrap">
            <img :src="imgUrl" alt="logo" />
          </div>
          <div class="logo-text">
            <span class="logo-title">农产品供应链服务平台</span>
            <!-- <span class="logo-sub">Aquatic Supply Chain Service Platform</span> -->
          </div>
        </router-link>
      </div>

      <!-- 导航菜单 -->
      <el-menu class="navbar-menu" mode="horizontal" :default-active="activeMenu" router>
        <div class="menu-items">
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/purchase">采购信息</el-menu-item>
          <el-menu-item index="/supply">供应信息</el-menu-item>
          <el-menu-item index="/price">价格参考</el-menu-item>
          <el-menu-item index="/merchants">优质商户</el-menu-item>
          <el-menu-item index="/news">平台公告</el-menu-item>
          <el-menu-item index="/publish">发布信息</el-menu-item>
          <el-menu-item index="/feedback">意见收集</el-menu-item>
        </div>
      </el-menu>

      <!-- 未登录时 -->
      <div v-if="!isLogin" class="auth-area">
        <el-button class="btn-login" @click="goLogin">登录</el-button>
        <el-button class="btn-register" @click="goRegister">注册</el-button>
      </div>

      <!-- 用户信息 -->
      <div v-if="isLogin" class="user-info">
        <el-dropdown @command="handleCommand">
          <div class="user-avatar-wrap">
            <div class="user-avatar">{{ name ? name[0] : 'U' }}</div>
            <span class="user-name">{{ name }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">
              <i class="el-icon-user"></i>
              个人中心
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <i class="el-icon-switch-button"></i>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 汉堡按钮（移动端） -->
      <div class="hamburger" @click="toggleMenu">
        <span :class="{ open: menuOpen }"></span>
        <span :class="{ open: menuOpen }"></span>
        <span :class="{ open: menuOpen }"></span>
      </div>
    </header>

    <!-- 移动端下拉菜单 -->
    <transition name="slide-down">
      <div v-if="menuOpen" class="mobile-menu">
        <router-link to="/home" class="mobile-menu-item" @click.native="closeMenu">
          首页
        </router-link>

        <router-link to="/purchase" class="mobile-menu-item" @click.native="closeMenu">
          采购信息
        </router-link>

        <router-link to="/supply" class="mobile-menu-item" @click.native="closeMenu">
          供应信息
        </router-link>

        <router-link to="/price" class="mobile-menu-item" @click.native="closeMenu">
          价格参考
        </router-link>

        <router-link to="/merchants" class="mobile-menu-item" @click.native="closeMenu">
          优质商户
        </router-link>

        <router-link to="/news" class="mobile-menu-item" @click.native="closeMenu">
          平台公告
        </router-link>

        <router-link to="/publish" class="mobile-menu-item" @click.native="closeMenu">
          发布信息
        </router-link>

        <router-link to="/feedback" class="mobile-menu-item" @click.native="closeMenu">
          发布信息
        </router-link>

        <div class="mobile-menu-divider"></div>
        <template v-if="!isLogin">
          <div
            class="mobile-menu-item"
            @click="
              () => {
                goLogin()
                closeMenu()
              }
            ">
            登录
          </div>
          <div
            class="mobile-menu-item"
            @click="
              () => {
                goRegister()
                closeMenu()
              }
            ">
            注册
          </div>
        </template>

        <template v-if="isLogin">
          <div
            class="mobile-menu-item"
            @click="
              () => {
                handleCommand('profile')
                closeMenu()
              }
            ">
            个人中心
          </div>
          <div
            class="mobile-menu-item logout"
            @click="
              () => {
                handleCommand('logout')
                closeMenu()
              }
            ">
            退出登录
          </div>
        </template>
      </div>
    </transition>

    <!-- 遮罩 -->
    <div v-if="menuOpen" class="mobile-overlay" @click="closeMenu"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import imgUrl from '@/assets/logo.png'

export default {
  name: 'Navbar',
  data() {
    return {
      imgUrl,
      menuOpen: false
    }
  },
  computed: {
    ...mapGetters(['name', 'isLogin']),
    activeMenu() {
      const route = this.$route
      const { path, meta } = route
      if (meta.hasOwnProperty('activeMenu')) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },

    closeMenu() {
      this.menuOpen = false
    },

    goLogin() {
      this.$store.dispatch('authModal/openModal', {
        mode: 'login',
        returnTo: this.$route.fullPath
      })
    },

    goRegister() {
      this.$router.push('/register')
    },

    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$store.dispatch('user/logout').then(() => {
              this.$message.success('已退出登录')
              this.$router.push('/')
              // location.reload()
            })
          })
          .catch(() => {})
      } else if (command === 'profile') {
        if (this.$route.path !== '/profile') {
          this.$router.push('/profile')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// ── 色彩变量 ──────────────────────────────
$accent: #0288d1; // 点缀蓝（用于 active 下划线）
$text-main: #1a2233;
$text-muted: #6b7a99;
$border: #e4eaf4;
$shadow: rgba(21, 101, 192, 0.08);

// 断点
$breakpoint-mobile: 768px;

// ── 导航根容器 ────────────────────────────
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1999;
  background: var(--primary);
  box-shadow: 0 2px 12px $shadow;
}

// ── 底部强调线 ────────────────────────────
.navbar-border {
  height: 3px;
  background: $accent;
  opacity: 0.85;
}

// ── 主容器 ────────────────────────────────
.header {
  display: flex;
  align-items: center;
  padding: 0 40px;
  height: 80px;
  background: var(--primary);

  @media (max-width: $breakpoint-mobile) {
    padding: 0 16px;
    height: 60px;
  }
}

// ── Logo ──────────────────────────────────
.logo {
  flex-shrink: 0;
  margin-right: 32px;

  .logo-link {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;

    // &:hover .logo-title {
    //   color: var(--primary);
    // }
  }

  .logo-icon-wrap {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: #e3f0fd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
  }

  .logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }

  .logo-title {
    font-size: 17px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.5px;
    transition: color 0.2s;

    @media (max-width: $breakpoint-mobile) {
      font-size: 15px;
    }
  }

  .logo-sub {
    font-size: 11px;
    color: var(--text-light);
    margin-top: 4px;
    letter-spacing: 0.3px;
    font-weight: 400;
  }
}

// ── 菜单 ──────────────────────────────────
.navbar-menu {
  flex: 1;
  border: none !important;
  background: transparent;
  height: 80px;
  overflow: hidden;

  .menu-items {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 10px;
  }

  :deep(.el-menu-item) {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-light);
    height: 60px;
    line-height: 60px;
    padding: 0 16px !important;
    // border-bottom: 3px solid transparent !important;
    transition: color 0.2s, background 0.2s;
    background: transparent !important;
    box-sizing: border-box;

    &:hover {
      color: #fff !important;
      background: var(--primary-light) !important;
      border-radius: 4px;
      height: 52px;
      line-height: 52px;
    }

    &.is-active {
      color: #fff !important;
      font-weight: 600;
      border-bottom-color: $accent !important;
      background: transparent !important;
    }
  }

  // 移动端隐藏PC菜单
  @media (max-width: $breakpoint-mobile) {
    display: none;
  }
}

// ── 登录/注册 ─────────────────────────────
.auth-area {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 20px;

  // 移动端隐藏，放到移动菜单里
  @media (max-width: $breakpoint-mobile) {
    display: none;
  }

  .btn-login {
    height: 36px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    border: 1.5px solid #fff;
    border-radius: 6px;
    background: transparent;
    transition: all 0.2s;

    &:hover {
      background: #e8f1fb;
      border-color: var(--primary-light);
      color: var(--primary-light);
    }
  }

  .btn-register {
    height: 36px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: var(--primary);
    border: 1.5px solid var(--primary);
    border-radius: 6px;
    transition: all 0.2s;

    &:hover {
      background: var(--primary-light);
      border-color: var(--primary-light);
    }
  }
}

// ── 用户信息 ──────────────────────────────
.user-info {
  flex-shrink: 0;
  margin-left: 20px;
  display: flex;

  @media (max-width: $breakpoint-mobile) {
    display: none;
  }

  .user-avatar-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 6px;
    transition: background 0.2s;

    &:hover {
      background: #f0f3f667;
    }
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f0f6ff;
    color: var(--primary);
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .user-name {
    color: #f0f6ff;
    font-size: 18px;
    font-weight: 500;
    max-width: 80px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }

  i {
    font-size: 16px;
    color: var(--text-light);
    margin-left: 28px;
  }
}

// ── 下拉菜单 ──────────────────────────────
:deep(.el-dropdown-menu__item) {
  font-size: 16px !important;
  padding: 8px 16px;
  color: $text-main;

  i {
    margin-right: 6px;
    color: var(--text-light);
  }

  &:hover {
    background: #f0f6ff !important;
    color: var(--primary) !important;

    i {
      color: var(--primary) !important;
    }
  }
}

// ── 汉堡按钮 ──────────────────────────────
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  margin-left: auto;
  flex-shrink: 0;

  @media (max-width: $breakpoint-mobile) {
    display: flex;
  }

  span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: all 0.3s ease;
    transform-origin: center;

    // 三条线变 X 动画
    &:nth-child(1).open {
      transform: translateY(7px) rotate(45deg);
    }
    &:nth-child(2).open {
      opacity: 0;
      transform: scaleX(0);
    }
    &:nth-child(3).open {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

// ── 移动端下拉菜单 ────────────────────────
.mobile-menu {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  background: rgba(211, 211, 211, 0.82);
  box-shadow: 0 8px 24px $shadow;
  z-index: 999;
  padding: 8px 0;

  .mobile-menu-item {
    display: block;
    padding: 14px 24px;
    font-size: 15px;
    color: $text-main;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;

    &:hover,
    &.router-link-active {
      background: #f0f6ff;
      color: var(--primary);
    }

    &.logout {
      color: #e53935;

      &:hover {
        background: #dedede;
        color: #e53935;
      }
    }
  }

  .mobile-menu-divider {
    height: 1px;
    background: $border;
    margin: 8px 16px;
  }
}

// ── 遮罩 ──────────────────────────────────
.mobile-overlay {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 998;
}

// ── 动画 ──────────────────────────────────
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.25s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

// ── 下拉菜单样式 ──────────────────────────
:deep(.el-dropdown-menu__item) {
  font-size: 0.18rem !important;
  padding: 0.08rem 0.16rem;
  color: $text-main;

  i {
    margin-right: 0.06rem;
    color: $text-muted;
  }

  &:hover {
    background: #f0f6ff !important;
    color: var(--primary) !important;

    i {
      color: var(--primary) !important;
    }
  }
}
</style>
